import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import {MEDIA_TYPE, MEDIA_TYPE_NAME_BY_ID, STREAM_STATUS} from '@/const';
import StaticBlockComponent from '../../components/StaticBlockComponent';
import TimeFlip from '../../components/video/TimeFlip';
import ChatComponent from '../components/Chats/ChatController.vue';
import ImageComponent from '../../components/base-components/ImageComponent';
import BlockedContentWrapper from '../../components/base-components/BlockedContentWrapper';
import ButtonComponent from '../../components/base-components/buttons/ButtonComponent';
import XMarkIcon from '../../assets/img/XMarkIcon';
import EmbeddedPlayer from '../../components/base-components/ebmeddedPlayer/embeddedPlayer';
import LoaderComponent from '../../components/LoaderComponent';
import {DOWNLOAD_EVENT, GET_EVENT, GET_SHAREDCLIP} from '@/store/actionTypes';
import {CLIPS, ERROR, LOGIN, SELECT_PACKAGE, SHARE} from '@/pages';
import ClipCutComponent from '../components/cliping/ClipCutComponent';
import {FAVORITE_TYPES} from '@/const';
import FavoriteStarToggle from '../../components/favorites/FavoriteStarToggle';
import DownloadButton from '@/components/base-components/buttons/DownloadButton';
import SportIcons from '@/assets/img/SportIcons';
import AdsenseBlock from '@/components/base-components/adsense/AdsenseBlock';
import PlayerController from '@/components/video/PlayerController.vue';
import {eventTeams, eventTimeObject} from '@/league/components/EventCards/eventMethods';
import {ADD_TOAST} from '@/store/mutationTypes';
import {GET_EVENT_PREROLLS} from '@/store/getterTypes';

const VIDEO_URL = 'https://js-lib-yare-analytics.s3.us-west-2.amazonaws.com/placeholders';


export default {
  components: {
    PlayerController,
    SportIcons,
    DownloadButton,
    FavoriteStarToggle,
    ClipCutComponent,
    LoaderComponent,
    EmbeddedPlayer,
    XMarkIcon,
    ButtonComponent,
    BlockedContentWrapper,
    ImageComponent,
    ChatComponent,
    TimeFlip,
    StaticBlockComponent,
    AdsenseBlock,
  },
  data() {
    return {
      event: {},
      clipEvent: {},
      videoOptions: {
        autostart: true,
        file: null,
      },
      analyticsOptions: {},
      showEmbeddedPreview: false,
      chatDisplayed: false,
      loading: false,
      playerInterface: null,
      videoPlaying: false,
      isClipsDisplayed: false,
      showScore: false,
      loadingclip: false,
    };
  },
  STREAM_STATUS: STREAM_STATUS,
  FAVORITES_TYPE: FAVORITE_TYPES,
  methods: {
    ...mapActions({
      getEvent: GET_EVENT,
      downloadEvent: DOWNLOAD_EVENT,
      getSharedClip: GET_SHAREDCLIP,
    }),
    ...mapMutations({
      addToast: ADD_TOAST,
    }),
    getMediaByType(type) {
      return this.event.media.find((item) => Number(item.media_type) === Number(type));
    },
    getMediaPropFromType(mediaType, prop) {
      const media = this.getMediaByType(mediaType);
      return prop ? media?.[prop] : media;
    },
    onTime() {
      const tenSec = 10 * 1000;
      const randomCount = Math.round(Math.random() * tenSec);
      const timeout = setTimeout(() => this.getEventInfo(), randomCount);
      this.loading = true;
      this.$once('hook:beforeDestroy', () => clearTimeout(timeout));
    },
    checkRedirects(id) {
      if (this.$store.getters.isLogged) {
        const to = {
          name: SELECT_PACKAGE.name,
          params: {
            id: id,
          },
        };
        this.$router.replace(to);
      } else {
        this.$router.push(LOGIN);
      }
    },
    getEventInfo() {
      if (!this.videoOptions.file) {
        this.loading = true;
      }
      this.getEvent(this.$route.params.id).then((data) => {
        const event = data.data;
        if (!this.isClipPage && !event.has_access && !event.is_geo_blocked) {
          this.checkRedirects(event.id);
          return;
        }
        this.event = event;
      }).catch((data) => {
        if (Number(data.status) === 404) {
          this.$router.push(ERROR);
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    getClipInfo() {
      this.loadingclip = true;
      this.getSharedClip(this.$route.params.uuid)
          .then((data) => {
            this.clipEvent = data;
          })
          .catch((data) => {
            if (Number(data.status) === 404) {
              this.$router.push(ERROR);
            }
          })
          .finally(() => {
            this.loadingclip = false;
          });
    },
    togglePreview(show) {
      this.showEmbeddedPreview = show;
      document.querySelector('body').classList.toggle('overflow-hidden', show);
    },
    toggleChat() {
      this.chatDisplayed = !this.chatDisplayed;
    },
    onInterfaceGet(methods) {
      this.playerInterface = methods;
    },
    onPlayChange(play) {
      this.videoPlaying = play;
    },
    toggleClipsComponent() {
      this.isClipsDisplayed = !this.isClipsDisplayed;
      localStorage.setItem('tutorial-click-clips', 'done');
    },
    toggleScore() {
      this.showScore = !this.showScore;
    },
  },
  watch: {
    event() {
      if (this.blocked) return;

      const thumbnails = this.getMediaPropFromType(MEDIA_TYPE.thumbnails, 'media_url');
      if (thumbnails) {
        this.videoOptions.tracks = [{
          file: thumbnails,
          kind: 'thumbnails',
        }];
      }
      if (this.isClipPage) return;

      this.videoOptions.file = this.getMediaPropFromType(this.streamStatus, 'media_url');
      if (this.event) {
        let prerollDisabled = false;
        if (this.event.stream_status === this.$options.STREAM_STATUS.live) {
          if (this.event.placeholder_live_comming) {
            this.videoOptions.file = `${VIDEO_URL}/livestream_delayed.mp4`;
            prerollDisabled = true;
          }
        }
        if (this.event.stream_status === this.$options.STREAM_STATUS.vod) {
          if (this.event.placeholder_vod_comming) {
            this.videoOptions.file = `${VIDEO_URL}/technical.mp4`;
            prerollDisabled = true;
          } else if (this.event.placeholder_vod_no) {
            this.videoOptions.file = `${VIDEO_URL}/event_unavailable.mp4`;
            prerollDisabled = true;
          }
        }

        if (!prerollDisabled) {
          const list = this.prerolls(this.event);
          if (list.length) {
            this.videoOptions.customPreRolls = {
              list,
              needTracking: false,
            };
          }
        }
      }

      const mediaId = this.getMediaPropFromType(this.streamStatus, 'media_type');
      this.analyticsOptions = {
        videoTitle: this.videoTitle,
        uniqueId: this.event.id,
        videoContentType: 'event',
        streamType: MEDIA_TYPE_NAME_BY_ID[mediaId] || '',
      };
    },
    clipEvent() {
      this.videoOptions.file = this.clipEvent.data.out_url;
    },
    needCutClip(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.addToast({
          text: `You’ve reached the limit for available clips.
          To view all your clips, please check 'My Account'`,
          link: CLIPS,
          linkTitle: 'Check my clips',
          time: 20000,
          type: 'success',
        });
      }
    },
    chatDisplayed() {
      if (this.chatDisplayed) {
        this.isClipsDisplayed = false;
      }
    },
    isClipsDisplayed() {
      if (this.isClipsDisplayed) {
        this.chatDisplayed = false;
      }
    },
  },
  computed: {
    ...mapState({
      capabilities: (state) => state.auth.capabilities,
      channelSettings: (state) => state.channel.settings,
      eventCategories: (state) => state.event.eventCategoriesById,
    }),
    ...mapGetters({
      prerolls: GET_EVENT_PREROLLS,
    }),
    needCutClip() {
      return this.event.can_clip;
    },
    streamStatus() {
      return this.event.stream_status === STREAM_STATUS.vod ? MEDIA_TYPE.vod : MEDIA_TYPE.live;
    },
    embedded() {
      return this.getMediaPropFromType(MEDIA_TYPE.embedded, 'media_info');
    },
    embeddedPreview() {
      return this.getMediaPropFromType(MEDIA_TYPE.embedded_preview, 'media_info');
    },
    videoTitle() {
      if (!this.event) {
        return '';
      }
      if (this.event.participants?.length === 2) {
        // eslint-disable-next-line max-len
        return `${this.trimParticipant(this.teams.awayTeam.name)} @ ${this.trimParticipant(this.teams.homeTeam.name)}`;
      }
      return this.event.name || '';
    },
    chatIsEnabled() {
      return !this.event.is_geo_blocked &&
          this.event?.stream_status === this.$options.STREAM_STATUS.live &&
          this.event?.chat;
    },
    eventImage() {
      return this.getMediaPropFromType(MEDIA_TYPE.image, 'media_url');
    },
    blocked() {
      return Boolean(this.event?.is_geo_blocked);
    },
    teams() {
      return eventTeams(this.event);
    },
    eventUpcoming() {
      return this.event.stream_status === this.$options.STREAM_STATUS.upcoming ||
          this.event.event_utc_ts * 1000 > +(new Date());
    },
    sport() {
      return this.eventCategories[this.event.event_category_id];
    },
    sportName() {
      return this.sport?.alias || this.sport?.name;
    },
    sportTagsName() {
      return this?.sport?.name;
    },
    gender() {
      if (this.teams.homeTeam.gender) {
        return this.teams.homeTeam.gender?.slice(0, 1).toUpperCase() === 'M' ? 'M' : 'W';
      }
      return null;
    },
    scoreEnabled() {
      return this.event.iframe;
    },
    countDownPreview() {
      const content = this.channelSettings.content;
      return parseInt(content['event-count-down-preview']) || 0;
    },
    isClipPage() {
      return this.$route.name === SHARE.name;
    },
    formattedTime() {
      return eventTimeObject(this.event);
    },
    canDownloadEvent() {
      return this.event.can_download && this.event.download_available;
    },
  },
  mounted() {
    this.getEventInfo();
    if (this.isClipPage) {
      this.getClipInfo();
    }
  },
};
